import { symbol } from "./symbol.js";
<ebay-icon ...input _name="checkbox-unchecked-18" _size="18" _type="icon" _themes=symbol/>